import { useState } from "react";

export const useOpenModal = () => {
    const [isOpenModal, setIsOpenModal] = useState(false);

    const toggleModalVisibility = () => {
        setIsOpenModal((prevState) => !prevState);
    }

    return {
        isOpenModal,          // Retorna o estado atual do modal
        toggleModalVisibility // Função para alternar a visibilidade
    }
}